import { render, staticRenderFns } from "./ContestOfferMainDataEmpty.vue?vue&type=template&id=035cd379&scoped=true&"
import script from "./ContestOfferMainDataEmpty.vue?vue&type=script&lang=js&"
export * from "./ContestOfferMainDataEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cd379",
  null
  
)

export default component.exports